import * as HttpService from "../../../../service/HttpService";


/**
 *  查询已读报告列表
 */
export const selectAlreadyList = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/energyAnalysis/selectAlreadyList", params);
};
/**
 * 删除空调经济模型
 */
export const delAlreadyReport = (params) => {
    return HttpService.get(HttpService.DOMAIN + "/energyAnalysis/delAlreadyReport?id="+params);
};